// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"371":"5d0d834f","927":"babce28b","939":"af4728ef"}[chunkId] + ".chunk.css";
};